const headerBackgroundDefaultCoords = {
  x: 0,
  y: 0,
};

export default headerBackgroundDefaultCoords;
